/** Poll until CTM is ready, then swap numbers. Re-runs after geo/React paints. */

export const CTM_TRACKING_SCRIPT = 'https://405201.tctm.co/t.js';

const RETRY_AFTER_READY_MS = [0, 50, 150, 400, 800, 1600, 3000, 5000];

function getRunNow() {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.__ctm?.main?.runNow || window.ctm?.main?.runNow || null;
}

function invokeRunNow() {
  const runNow = getRunNow();
  if (typeof runNow !== 'function') {
    return false;
  }
  try {
    runNow.call(window.__ctm?.main || window.ctm?.main);
    return true;
  } catch (error) {
    return false;
  }
}

function scheduleFollowUpRuns() {
  RETRY_AFTER_READY_MS.forEach((ms) => {
    setTimeout(invokeRunNow, ms);
  });
}

export function loadCtmScript() {
  if (typeof document === 'undefined') {
    return;
  }

  if (!document.querySelector('script[src*="tctm.co/t.js"]')) {
    const script = document.createElement('script');
    script.async = true;
    script.src = CTM_TRACKING_SCRIPT;
    script.onload = () => runCtmWhenReady();
    document.head.appendChild(script);
  }

  runCtmWhenReady();
}

export function runCtmWhenReady() {
  if (typeof window === 'undefined') {
    return;
  }

  if (invokeRunNow()) {
    scheduleFollowUpRuns();
    return;
  }

  if (window.__ctmPollTimer) {
    return;
  }

  const maxAttempts = 120;
  let attempts = 0;

  const tick = () => {
    attempts += 1;
    if (invokeRunNow()) {
      window.__ctmPollTimer = null;
      scheduleFollowUpRuns();
      return;
    }
    if (attempts < maxAttempts) {
      window.__ctmPollTimer = setTimeout(tick, 250);
    } else {
      window.__ctmPollTimer = null;
    }
  };

  window.__ctmPollTimer = setTimeout(tick, 250);
}
